'use strict';

module.exports = {
  pricing: 0,
  wholesale: 1,
  inputs: 2,
  settings: 3,
  reporting: 4,
  dashboards: 5,
};
